import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    DATE_RANGE_FIELD_TYPE,
    AUTOCOMPLETE_FIELD_TYPE,
    NUMERIC_RANGE_FIELD_TYPE,
    BOOLEAN_FIELD_TYPE,
} from "../../helpers/constants";
import { IconButton } from "@mui/material";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { useProposalFilteringData } from "../../services/productsService";

import { formatCurrency } from "../../components/common/PriceDisplay";
import DateService from "../../services/dateService";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import FlakyIcon from '@mui/icons-material/Flaky';
import { convertFlatListFromBackendToTranslatedOptionObject } from "../../helpers/methods";

export const PROPOSAL_TABLE_NAME = "proposal_accept_table";

export const useProposalAcceptDialogTableFieldConfig = (proposalType) => {
    const { t } = useTranslation();

    let config = [
        {
            name: "creator",
            getValueCallback: (rowData) => rowData.creator,
            label: t("products.columns.creator"),
        },
        {
            name: "created",
            getValueCallback: (rowData) =>
                DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.created),
            label: t("products.columns.proposal_created")
        },
        {
            name: "investment",
            getValueCallback: (rowData) => rowData.investment,
            label: t("products.columns.investment"),
        },
        {
            name: "product_number",
            getValueCallback: (rowData) => rowData.product_number,
            label: t("products.columns.product_number"),
        },
        {
            name: "product_price_net",
            getValueCallback: (rowData) => rowData.product_price_net,
            label: t("products.columns.product_price_net"),
        },
        {
            name: "product_price_gross",
            getValueCallback: (rowData) => rowData.product_price_gross,
            label: t("products.columns.product_price_gross"),
        },
        {
            name: "product_discount",
            getValueCallback: (rowData) => rowData.product_discount.toFixed(2),
            label: t("products.columns.product_discount"),
        },
        {
            name: "proposal_discount",
            getValueCallback: (rowData) => rowData.proposal_discount.toFixed(2),
            label: t("products.columns.proposal_discount"),
        },
        {
            name: "product_status",
            getValueCallback: (rowData) => rowData.product_status,
            label: t("products.columns.product_status"),
        },
        {
            name: "proposal_status",
            getValueCallback: (rowData) => rowData.proposal_status,
            label: t("products.columns.proposal_status"),
        },
        {
            name: "proposal_note",
            getValueCallback: (rowData) => rowData.proposal_note,
            label: t("products.columns.proposal_note"),
        },
    ]

    if (proposalType === 'discount'){
        config = config.filter(column=>!['product_status', 'proposal_status'].includes(column.name))
    }

    if (proposalType === 'status'){
        config = config.filter(column=>!['product_discount', 'proposal_discount'].includes(column.name))
    }

    return config
};
